<div class="fm-rs-steps">

  <!-- Page Title -->
  <div class="fm-page-title">
    <h1 class="fm-head-24 fm-title">Create a New Memory</h1>
  </div>

  <!-- Step Header -->
  <div class="fm-rs-step-wrapper">
    <div class="fm-step-wrapper">
      <div class="fm-white-column">
        <div class="fm-step-list">
          <div class="fm-step-item" [class.active]="currentStep() >= 1" [class.completed]="currentStep() > 1"
               (click)="currentStep() > 1 && goToStep(1)" role="button" tabindex="0" aria-label="Step 1">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step1-icon.svg" alt="Step 1" />
            </div>
            <div class="fm-step-number">Step 01</div>
            <div class="fm-step-title">Choose Category</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 2" [class.completed]="currentStep() > 2"
               (click)="currentStep() > 2 && goToStep(2)" role="button" tabindex="0" aria-label="Step 2">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step2-icon.svg" alt="Step 2" />
            </div>
            <div class="fm-step-number">Step 02</div>
            <div class="fm-step-title">Select Media Type</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 3" [class.completed]="currentStep() > 3"
               (click)="currentStep() > 3 && goToStep(3)" role="button" tabindex="0" aria-label="Step 3">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step3-icon.svg" alt="Step 3" />
            </div>
            <div class="fm-step-number">Step 03</div>
            <div class="fm-step-title">Select Questions</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 4"
               role="button" tabindex="0" aria-label="Step 4">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step4-icon.svg" alt="Step 4" />
            </div>
            <div class="fm-step-number">Step 04</div>
            <div class="fm-step-title">Answer Questions</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- STEP 1: Choose Category                                       -->
    <!-- ============================================================ -->
    @if (currentStep() === 1) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-section-title">
              <h2 class="fm-head-24">What Kind Of Memory Would You Like To Share?</h2>
              <p>Choose a category to get started with AI-powered prompts</p>
            </div>
                        @if (loadingCategories()) {
              <div class="fm-category-grid fm-skeleton-grid">
                @for (_ of [1,2,3,4,5,6,7,8]; track $index) {
                  <div class="fm-skeleton-category-card">
                    <div class="fm-skeleton-icon"></div>
                    <div class="fm-skeleton-line fm-skeleton-line--title"></div>
                    <div class="fm-skeleton-line fm-skeleton-line--sub"></div>
                  </div>
                }
              </div>
            } @else {
              <div class="fm-category-grid">
                @for (cat of apiCategories(); track cat.categoryId) {
                  <div class="fm-category-box">
                    <input type="radio" name="memory" [id]="'cat-' + cat.categoryId"
                           [checked]="selectedCategory() === cat.categoryId"
                           (change)="selectCategory(cat.categoryId)" />
                    <label class="fm-category-label" [for]="'cat-' + cat.categoryId">
                      <div class="fm-check-icon">
                        <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                      </div>
                      <div class="fm-category-icon">
                        <img [src]="getCategoryIcon(cat)" class="fm-svg" [alt]="cat.categoryName" />
                      </div>
                      <h4 class="fm-head-22">{{ cat.categoryName }}</h4>
                      <p>{{ cat.totalPrompt }} prompts available</p>
                    </label>
                  </div>
                }
              </div>
            }
          </div>
          </div>
          <div class="fm-form-footer">
          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="cancelRecord()">
            Cancel
          </button>
          <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="nextStep()">
            Continue
            <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
          </button>
        </div>
      </div>
    }

    <!-- ============================================================ -->
    <!-- STEP 2: Select Media Type                                     -->
    <!-- ============================================================ -->
    @if (currentStep() === 2) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-compressed-cl">
              <div class="fm-section-title">
                <h2 class="fm-head-24">How Would You Like To Tell Your Story?</h2>
                <p>Choose the best way to capture your memories</p>
              </div>
              <div class="fm-media-list">
                @for (media of mediaTypes; track media.id) {
                  <div class="fm-media-card" [class.active]="selectedMedia() === media.id"
                       (click)="selectMedia(media.id)" role="button" tabindex="0">
                    <div class="fm-media-left">
                      <div class="fm-media-icon">
                        <img [src]="media.icon" class="fm-svg" [alt]="media.label" />
                      </div>
                      <div>
                        <h4 class="fm-head-22">{{ media.label }}</h4>
                        <p>{{ media.description }}</p>
                      </div>
                    </div>
                    <div class="fm-check-icon">
                      <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="fm-compressed-cl">
          <div class="fm-form-footer fm-space-between">
            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
              Back
            </button>
            <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="nextStep()">
              Continue
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
            </button>
          </div>
        </div>
      </div>
    }

    <!-- ============================================================ -->
    <!-- STEP 3: Select Questions                                      -->
    <!-- ============================================================ -->
    @if (currentStep() === 3) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-compressed-cl fm-large-cl">
              <div class="fm-section-title">
                <h2 class="fm-head-24">Select Questions</h2>
                <p>Choose which questions to answer in your story</p>
              </div>

              @if (loadingPrompts()) {
                <div class="fm-question-list fm-skeleton-question-list">
                  @for (_ of [1,2,3,4,5]; track $index) {
                    <div class="fm-skeleton-question-card">
                      <div class="fm-skeleton-num"></div>
                      <div class="fm-skeleton-line fm-skeleton-line--q"></div>
                    </div>
                  }
                </div>
              } @else if (questions().length === 0) {
                <p class="text-muted fm-small py-3">No questions available for this category.</p>
              } @else {
                <div class="fm-questions-header mb-2">
                  <span class="fm-selected-count">
                    {{ selectedQuestions().length }} of {{ questions().length }} selected
                  </span>
                  <div class="fm-select-actions">
                    <button type="button" class="fm-link-btn" (click)="selectAllQuestions()">Select All</button>
                    <span class="fm-divider">&nbsp;|&nbsp;</span>
                    <button type="button" class="fm-link-btn" (click)="clearAllQuestions()">Clear All</button>
                  </div>
                </div>
                <div class="fm-question-list">
                  @for (q of questions(); track q.id; let i = $index) {
                    <div class="fm-question-card" [class.active]="q.selected"
                         [class.fm-question-custom]="q.isCustom"
                         (click)="editingQuestionId() !== q.id && toggleQuestion(q.id)" role="checkbox"
                         [attr.aria-checked]="q.selected" tabindex="0"
                         (keydown.enter)="editingQuestionId() !== q.id && toggleQuestion(q.id)"
                         (keydown.space)="$event.preventDefault(); editingQuestionId() !== q.id && toggleQuestion(q.id)">
                      <span class="fm-question-number">{{ (i + 1).toString().padStart(2, '0') }}</span>
                      @if (editingQuestionId() === q.id) {
                        <div class="fm-inline-edit" (click)="$event.stopPropagation()">
                          <input type="text" class="form-control fm-inline-edit-input"
                                 [value]="editingQuestionText()"
                                 (input)="editingQuestionText.set($any($event.target).value)"
                                 (keydown.enter)="saveEditQuestion()"
                                 (keydown.escape)="cancelEditQuestion()" />
                          <button type="button" class="btn fm-icon-btn fm-icon-btn-save" (click)="saveEditQuestion()" aria-label="Save">
                            <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                          </button>
                          <button type="button" class="btn fm-icon-btn fm-icon-btn-cancel" (click)="cancelEditQuestion()" aria-label="Cancel">
                            <img src="images/icons/fm-trash.svg" class="fm-svg" alt="Cancel" />
                          </button>
                        </div>
                      } @else {
                        <p class="mb-0 fm-question-text">{{ q.text }}</p>
                      }
                      @if (q.isCustom && editingQuestionId() !== q.id) {
                        <div class="fm-question-actions fm-dropdown" (click)="$event.stopPropagation()">
                          <button type="button" class="fm-question-menu-btn"
                                  (click)="toggleQuestionMenu(q.id, $event)"
                                  aria-label="Open question actions">
                            <img src="images/icons/fm-vertical-dots.svg" class="fm-svg" alt="Actions" />
                          </button>
                          @if (openMenuId() === q.id) {
                            <div class="dropdown-menu fm-dropdown-menu show">
                              <button type="button" class="dropdown-item fm-dropdown-item fm-dropdown-edit"
                                      (click)="startEditQuestion(q.id)">
                                <img src="images/icons/fm-edit.svg" class="fm-svg" alt="Edit" />
                                <span class="fm-question-action-label">Edit</span>
                              </button>
                              <button type="button" class="dropdown-item fm-dropdown-item"
                                      (click)="deleteQuestion(q.id)">
                                <img src="images/icons/fm-delete.svg" class="fm-svg" alt="Delete" />
                                <span class="fm-question-action-label">Delete</span>
                              </button>
                            </div>
                          }
                        </div>
                      }
                      <div class="fm-check-icon" aria-hidden="true">
                        <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="" />
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- Add Custom Question -->
              <div class="fm-add-question-btn">
                <button type="button" class="fm-common-btn" (click)="toggleCustomQuestion()">
                  <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Add" />
                  Add Your Own Questions
                </button>
              </div>
              @if (showCustomQuestion()) {
                <div class="fm-custom-question">
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Type your question..."
                           [value]="customQuestionText()"
                           (input)="customQuestionText.set($any($event.target).value)" />
                    <button type="button" class="btn fm-icon-btn" (click)="saveCustomQuestion()" aria-label="Save question">
                      <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                    </button>
                    <button type="button" class="btn fm-icon-btn" (click)="toggleCustomQuestion()" aria-label="Cancel">
                      <img src="images/icons/fm-trash.svg" class="fm-svg" alt="Cancel" />
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="fm-compressed-cl fm-large-cl">
          <div class="fm-form-footer fm-space-between">
            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
              Back
            </button>
            <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt"
                    [disabled]="selectedQuestions().length === 0" (click)="nextStep()">
              Continue
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
            </button>
          </div>
        </div>
      </div>
    }

    <!-- ============================================================ -->
    <!-- STEP 4: Answer Questions (Recording)                         -->
        <!-- ============================================================ -->
    @if (currentStep() === 4) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="row g-4">

            <!-- Main Recording Area -->
            <div class="col-lg-8">
              <div class="fm-recording-wrapper">

                <!-- Progress -->
                <div class="fm-progress-wrapper">
                  <p class="fm-que-txt">Question {{ currentQuestionIndex() + 1 }} of {{ selectedQuestions().length }}</p>
                  <p class="fm-pcompleted-count">{{ progressPercent() }}% Completed</p>
                </div>
                <div class="progress fm-progress-bar" role="progressbar"
                     [attr.aria-valuenow]="progressPercent()" aria-valuemin="0" aria-valuemax="100">
                  <div class="progress-bar" [style.width.%]="progressPercent()"></div>
                </div>

                <!-- Current Question -->
                <div class="fm-question-box">
                  <p class="mb-2">Question {{ currentQuestionIndex() + 1 }}</p>
                  <h4 class="fm-head-20">{{ currentQuestion()?.text }}</h4>
                </div>

                <!-- Video Recording -->
                @if (selectedMedia() === 'video') {
                  <div class="fm-video-box">
                    <div class="fm-video-preview" [attr.data-recording-state]="recordingState()">
                      @if (recordingState() === 'idle' && !recordedUrl() && !uploadedUrl()) {
                        <div class="fm-video-icon">
                          <img src="images/icons/fm-video-lg.svg" class="fm-svg" alt="Video Preview" />
                        </div>
                        <p class="fm-record-status mb-0">Ready to record</p>
                      }
                      <video #videoPreview class="fm-video-element"
                             [class.d-none]="recordingState() === 'idle' && !recordedUrl() && !uploadedUrl()"
                             autoplay playsinline
                             disablepictureinpicture
                             disableremoteplayback
                             controlslist="nodownload noplaybackrate"></video>
                      @if (recordingState() === 'recording') {
                        <div class="fm-recording-indicator" aria-live="polite">
                          <span class="fm-rec-dot" aria-hidden="true"></span>
                          <span class="fm-rec-time">{{ formatRecordingTime(recordingTimer()) }}</span>
                        </div>
                      }
                    </div>
                    <div class="fm-video-btn">
                      <div class="row g-3 g-xl-4">
                        @if (recordingState() !== 'recording') {
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100"
                                    (click)="startVideoRecording()">
                              <img src="images/icons/fm-record.svg" class="fm-svg" alt="Record" />
                              {{ (recordedUrl() || uploadedUrl()) ? 'Re-record Video' : 'Record Video' }}
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <label for="videoUploadInput"
                                   class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-upload-btn fm-large-btn w-100"
                                   style="cursor:pointer">
                              <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload" />
                              Upload Video
                            </label>
                            <input type="file" id="videoUploadInput" class="d-none" accept="video/*"
                                   (change)="onVideoUpload($event)" />
                            @if (uploadErrorMsg()) {
                              <div class="fm-upload-error" role="alert">
                                <span>&#9888;</span> {{ uploadErrorMsg() }}
                              </div>
                            }
                          </div>
                        } @else {
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-large-btn w-100"
                                    (click)="retakeRecording()">
                              <img src="images/icons/fm-reset.svg" class="fm-svg" alt="Retake" />
                              Retake
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100 fm-btn-recording"
                                    (click)="stopRecording()">
                              <img src="images/icons/fm-recording-dot.svg" class="fm-svg" alt="Stop" />
                              Stop Recording
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                    @if (permissionError() && selectedMedia() === 'video') {
                      <div class="alert alert-danger mt-3 mb-0" role="alert">
                        <strong>{{ permissionError() }}</strong>
                        @if (isPermissionDenied()) {
                          <div class="mt-2">
                            Set Camera &amp; Microphone to <strong>Allow</strong>, then reload the page and try again.
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                <!-- Audio Recording -->
                @if (selectedMedia() === 'audio') {
                  <div class="fm-audio-box">
                    <div class="fm-audio-preview" [attr.data-recording-state]="recordingState()">
                      <!-- Idle / stopped: microphone icon -->
                      @if (recordingState() !== 'recording') {
                        <div class="fm-audio-icon">
                          <img src="images/icons/fm-micro-icon.svg" class="fm-svg" alt="Audio" />
                        </div>
                      }
                      <!-- Recording: animated waveform bars -->
                      @if (recordingState() === 'recording') {
                        <div class="fm-audio-visualizer" aria-hidden="true">
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                          <span class="fm-av-bar"></span>
                        </div>
                        <div class="fm-audio-rec-row">
                          <span class="fm-rec-dot" aria-hidden="true"></span>
                          <p class="fm-record-status mb-0" aria-live="polite">
                            Recording... {{ formatRecordingTime(recordingTimer()) }}
                          </p>
                        </div>
                      }
                      <audio #audioPreview class="fm-audio-player w-100 mt-3"
                             [class.d-none]="recordingState() !== 'stopped' || (!recordedUrl() && !uploadedUrl())"
                             controls></audio>
                    </div>
                    <div class="fm-audio-btn">
                      <div class="row g-3 g-xl-4">
                        @if (recordingState() !== 'recording') {
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100"
                                    (click)="startAudioRecording()">
                              <img src="images/icons/fm-record.svg" class="fm-svg" alt="Record" />
                              {{ (recordedUrl() || uploadedUrl()) ? 'Re-record Audio' : 'Record Audio' }}
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <label for="audioUploadInput"
                                   class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-upload-btn fm-large-btn w-100"
                                   style="cursor:pointer">
                              <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload" />
                              Upload Audio
                            </label>
                            <input type="file" id="audioUploadInput" class="d-none" accept="audio/*"
                                   (change)="onAudioUpload($event)" />
                            @if (audioUploadErrorMsg()) {
                              <div class="fm-upload-error" role="alert">
                                <span>&#9888;</span> {{ audioUploadErrorMsg() }}
                              </div>
                            }
                          </div>
                        } @else {
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-large-btn w-100"
                                    (click)="retakeAudioRecording()">
                              <img src="images/icons/fm-reset.svg" class="fm-svg" alt="Retake" />
                              Retake
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100 fm-btn-recording"
                                    (click)="stopRecording()">
                              <img src="images/icons/fm-recording-dot.svg" class="fm-svg" alt="Stop" />
                              Stop Recording
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                    @if (permissionError() && selectedMedia() === 'audio') {
                      <div class="alert alert-danger mt-3 mb-0" role="alert">
                        <strong>{{ permissionError() }}</strong>
                        @if (isPermissionDenied()) {
                          <div class="mt-2">
                            Set Microphone to <strong>Allow</strong>, then reload the page and try again.
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                <!-- Image + Audio -->
                @if (selectedMedia() === 'image-audio') {
                  <div class="fm-audio-box">
                    <div class="fm-audio-preview" [attr.data-recording-state]="recordingState()">
                      @if (!imagePreviewUrl()) {
                        <label for="fmImageAudioInput" class="fm-audio-icon fm-audio-upload-label" style="cursor:pointer">
                          <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload Photo" />
                        </label>
                        <p class="mb-0 mt-2">Drop your photo here, or <span class="fm-browse-link" (click)="imageAudioInput.click()">Browse</span></p>
                        <input type="file" #imageAudioInput id="fmImageAudioInput" class="d-none" accept="image/*"
                               (change)="onImageForAudioUpload($event)" />
                      } @else {
                        <div class="fm-img-preview-block">
                          <div class="fm-img-preview-thumb-wrap">
                            <img [src]="imagePreviewUrl()" class="fm-img-preview-thumb" alt="Uploaded Photo" />
                            <button type="button" class="fm-img-remove-corner" (click)="removeImageForAudio()"
                                    title="Remove image" aria-label="Remove image">
                              <i class="bi bi-x"></i>
                            </button>
                          </div>
                        </div>
                        <input type="file" id="fmImageAudioInput" class="d-none" accept="image/*"
                               (change)="onImageForAudioUpload($event)" />
                      }
                      <div class="fm-audio-waveform mt-3" aria-hidden="true">
                        @if (recordingState() === 'recording') {
                          <div class="fm-audio-visualizer" aria-hidden="true">
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                            <span class="fm-av-bar"></span>
                          </div>
                          <div class="fm-audio-rec-row mt-2">
                            <span class="fm-rec-dot" aria-hidden="true"></span>
                            <p class="fm-record-status mb-0" aria-live="polite">
                              Recording... {{ formatRecordingTime(recordingTimer()) }}
                            </p>
                          </div>
                        } @else {
                          <img src="images/icons/fm-audio-wave.svg" class="fm-audio-wave-img" alt="Wave" />
                        }
                      </div>
                      <audio #audioPreview class="fm-audio-player w-100 mt-3"
                             [class.d-none]="recordingState() !== 'stopped' || (!recordedUrl() && !uploadedUrl())"
                             controls></audio>
                    </div>
                    <div class="fm-audio-btn">
                      <div class="row g-3 g-xl-4">
                        @if (recordingState() !== 'recording') {
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100"
                                    (click)="startAudioRecording()">
                              <img src="images/icons/fm-record.svg" class="fm-svg" alt="Record" />
                              {{ (recordedUrl() || uploadedUrl()) ? 'Re-record Audio' : 'Record Audio' }}
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <label for="audioUploadInputImageAudio"
                                   class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-upload-btn fm-large-btn w-100"
                                   style="cursor:pointer">
                              <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload" />
                              Upload Audio
                            </label>
                            <input type="file" id="audioUploadInputImageAudio" class="d-none" accept="audio/*"
                                   (change)="onAudioUpload($event)" />
                            @if (audioUploadErrorMsg()) {
                              <div class="fm-upload-error" role="alert">
                                <span>&#9888;</span> {{ audioUploadErrorMsg() }}
                              </div>
                            }
                          </div>
                        } @else {
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-large-btn w-100"
                                    (click)="retakeAudioRecording()">
                              <img src="images/icons/fm-reset.svg" class="fm-svg" alt="Retake" />
                              Retake
                            </button>
                          </div>
                          <div class="col-sm-6">
                            <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100 fm-btn-recording"
                                    (click)="stopRecording()">
                              <img src="images/icons/fm-recording-dot.svg" class="fm-svg" alt="Stop" />
                              Stop Recording
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                    @if (permissionError() && selectedMedia() === 'image-audio') {
                      <div class="alert alert-danger mt-3 mb-0" role="alert">
                        <strong>{{ permissionError() }}</strong>
                        @if (isPermissionDenied()) {
                          <div class="mt-2">
                            Set Microphone to <strong>Allow</strong>, then reload the page and try again.
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                <!-- Footer Nav -->
                <div class="fm-form-footer fm-space-between">
                  <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn"
                          (click)="prevStep()">
                    <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
                    Back
                  </button>
                  @if (!allQuestionsAnswered()) {
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt"
                            (click)="nextQuestion()"
                            [disabled]="!canNavigateQuestions()">
                      Next Question
                      <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
                    </button>
                  } @else {
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt"
                            (click)="finishAndReview()">
                      Finish &amp; Review
                      <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Finish" />
                    </button>
                  }
                </div>

              </div>
            </div>

            <!-- Sidebar: Questions List + Tips -->
            <div class="col-lg-4">
              <div class="row g-4">

                <!-- Questions List Accordion -->
                <div class="col-12 col-sm-6 col-lg-12">
                  <div class="fm-sidebar-card fm-question-list-accordion">
                    <div class="fm-sidebar-title">
                      <button type="button" class="fm-question-list-toggle"
                              [attr.aria-expanded]="questionsAccordionOpen()"
                              aria-controls="fmStep4QuestionsList"
                              (click)="toggleQuestionsAccordion()">
                        <span class="fm-head-20">Questions List</span>
                        <img src="images/icons/fm-down-ar-tin.svg"
                             class="fm-svg fm-ql-acc-arrow"
                             [class.fm-ql-acc-arrow-up]="questionsAccordionOpen()"
                             alt="Toggle Questions" />
                      </button>
                    </div>
                    @if (questionsAccordionOpen()) {
                      <div class="fm-question-list fm-collapse" id="fmStep4QuestionsList">
                        @for (q of selectedQuestions(); track q.id; let i = $index) {
                          <div class="fm-question-card"
                               [class.active]="i === currentQuestionIndex()"
                               [class.fm-answered]="q.answered"
                               [class.fm-disabled]="!canNavigateQuestions()"
                               (click)="jumpToQuestion(i)"
                               style="cursor:pointer"
                               role="button"
                               [attr.aria-disabled]="!canNavigateQuestions()"
                               tabindex="0"
                               (keydown.enter)="jumpToQuestion(i)"
                               (keydown.space)="$event.preventDefault(); jumpToQuestion(i)"
                               [attr.aria-label]="'Question ' + (i + 1) + ': ' + q.text">
                            <span class="fm-question-number">{{ (i + 1).toString().padStart(2, '0') }}</span>
                            <p class="mb-0 fm-question-text">{{ q.text }}</p>
                            @if (getQuestionTimeframe(q.id)) {
                              <span class="fm-timeframe-badge">
                                {{ formatRecordingTime(getQuestionTimeframe(q.id)!.startSecond) }} - {{ formatRecordingTime(getQuestionTimeframe(q.id)!.endSecond) }}
                              </span>
                            }
                            <div class="fm-check-icon"
                               aria-hidden="true">
                              <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="" />
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>

                <!-- Recording Tips -->
                <div class="col-12 col-sm-6 col-lg-12">
                  <div class="fm-sidebar-card">
                    <div class="fm-sidebar-title">
                      <h5 class="fm-head-20">Recording Tips</h5>
                    </div>
                    <div class="fm-recording-tips-list">
                      <div class="fm-detail-item">
                        <div class="fm-detail-icon">
                          <img class="fm-svg" src="images/icons/fm-speak-sm.svg" alt="Tip" />
                        </div>
                        <div class="fm-detail-content">
                          <p class="fm-detail-text">Speak naturally, as if talking to a friend</p>
                        </div>
                      </div>
                      <div class="fm-detail-item">
                        <div class="fm-detail-icon">
                          <img class="fm-svg" src="images/icons/fm-clock-sm.svg" alt="Tip" />
                        </div>
                        <div class="fm-detail-content">
                          <p class="fm-detail-text">Take your time &amp; pause when needed</p>
                        </div>
                      </div>
                      <div class="fm-detail-item">
                        <div class="fm-detail-icon">
                          <img class="fm-svg" src="images/icons/fm-check-sm.svg" alt="Tip" />
                        </div>
                        <div class="fm-detail-content">
                          <p class="fm-detail-text">Include specific details and emotions</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    }

  </div>


  <!-- Reload Warning Modal -->
  @if (showReloadWarning()) {
    <div class="fm-reload-overlay" role="dialog" aria-modal="true" aria-labelledby="reloadModalTitle">
      <div class="fm-reload-modal">
        <div class="fm-reload-modal-icon">
          <span>&#9888;</span>
        </div>
        <h3 class="fm-reload-modal-title" id="reloadModalTitle">Leave this page?</h3>
        <p class="fm-reload-modal-desc">Your story progress will be <strong>permanently lost</strong> if you refresh or leave. You'll need to start the entire process again.</p>
        <div class="fm-reload-modal-actions">
          <button type="button" class="fm-common-btn fm-primary-btn" (click)="dismissReloadWarning()">Stay &amp; Continue</button>
          <button type="button" class="fm-reload-leave-btn" (click)="confirmReload()">Leave anyway</button>
        </div>
      </div>
    </div>
  }

  <!-- Delete Question Confirmation Modal -->
  @if (deleteConfirmId()) {
    <div class="fm-reload-overlay" role="dialog" aria-modal="true" aria-labelledby="deleteModalTitle">
      <div class="fm-reload-modal">
        <div class="fm-reload-modal-icon">
          <span>&#9888;</span>
        </div>
        <h3 class="fm-reload-modal-title" id="deleteModalTitle">Delete Question</h3>
        <p class="fm-reload-modal-desc">Are you sure you want to delete this question?</p>
        <div class="fm-reload-modal-actions">
          <button type="button" class="fm-common-btn fm-primary-btn" (click)="confirmDelete()">Yes, Delete</button>
          <button type="button" class="fm-reload-leave-btn" (click)="cancelDelete()">Cancel</button>
        </div>
      </div>
    </div>
  }
</div>
